var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-matrix-body"},[(_vm.value)?_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v("check_circle")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }